<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-form :model="searchItem" label-width="auto" inline size="small">
        <el-form-item label="用户ID">
          <el-input v-model.trim="searchItem.user_id" clearable></el-input>
        </el-form-item>
        <el-form-item label="IP地址">
          <el-input v-model.trim="searchItem.ip" clearable></el-input>
        </el-form-item>
        <el-form-item label="MAC地址">
          <el-input v-model.trim="searchItem.mac" clearable></el-input>
        </el-form-item>
        <el-form-item label="VLANID">
          <el-input v-model.trim="searchItem.vlan_id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="username" slot-scope="{row}">
          <template v-if="row.user">
            <el-button class="black" type="text" @click="$router.push({path: '/user/list', query: {username: row.user.username}})">
              {{row.user.username}}
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
        <template slot="sn" slot-scope="{row}">
          <template v-if="row.device">
            <el-button class="black" type="text" @click="$router.push({path: '/device/list', query: {sn: row.device.sn}})">
              <span class="btn-text" :title="`${row.device.sn}(${row.device.name})`">{{`${row.device.sn}(${row.device.name})`}}</span>
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
        <template slot="online_seconds" slot-scope="{row}">
          {{timeStamp(row.online_seconds)}}
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"/>
    </el-footer>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  export default {
    name: "onlineTerminal",
    mixins: [PagingData],
    components: {Statistics},
    data() {
      return {
        // 查询项
        searchItem: {
          user_id: "",
          ip: "",
          mac: "",
          vlan_id: "",
        },
        commitItem: null,
        // 统计
        countList: [
          {name: "总记录", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "上网账号", property: "username"},
            {label: "设备SN", property: "sn"},
            {label: "MAC地址", property: "mac"},
            {label: "IP地址", property: "ip"},
            {label: "VLANID", property: "vlan_id"},
            {label: "登录时间", property: "login_at"},
            {label: "上线时长", property: "online_seconds"},
          ],
        },
      }
    },
    methods: {
      /**其他*/
      // 查询
      search() {
        this.commitItem = {...this.searchItem};
        this.pagingData.currentPage = 1;
        this.getTableList();
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        // 添加筛选项
        this.copyObjValue(nv, this.commitItem);
        let res = await this.$Http.getOnlineTerminal(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
          // this.tableData.tableList.push({"id":48,
          //   "login_at":"2021-07-16 17:00:26",
          //   "logout_at":null,
          //   "user_id":431,
          //   "device_id":23,
          //   "online":1,
          //   "mac":"28:D1:27:41:E1:CD",
          //   "ip":"172.16.2.5",
          //   "vlan_id":"0",
          //   "delete":0,
          //   "online_seconds":1219452,
          //   "user":{
          //     "id":431,
          //     "name":"",
          //     "username":"s305s305"
          //   },
          //   "device":{
          //     "id":23,
          //     "name":"FBM-220G_CB20BA",
          //     "sn":"RG4719120871CB20BA"
          //   }})
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped lang="scss">
  .el-button {
    width: 100%;
    .btn-text {
      width: 100%;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
</style>
